<template>
  <div class="mc-cart">
    <div class="mc-container">
      <div v-if="basketLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="basketError" class="mc-error">{{ basketError }}</div>
      <form v-if="basketLoaded && basket.quantity> 0" class="mc-cart__form mc-cart-form" id="cartForm" method="post" autocomplete="off">
        <div class="mc-cart-form__quantity">
          {{basket.quantity}} {{ num_word(basket.quantity, ['товар', 'товара', 'товаров']) }}
        </div>
        <ul class="mc-cart-form__list">
          <template v-for="item in basket_items">
          <li v-if="!item.delete" class="mc-cart-form__item mc-cart-item">
            <div class="mc-cart-item__top">
              <div class="mc-cart-item__sizes">
                <button @click="sizeOpen = item.id" class="mc-underline-link js-modal-button" data-target="sizesSelect" type="button">
                                        <span class="mc-underline-link__text">
                                           {{item.size }}
                                        </span>
                </button>
                <div class="mc-modal" id="sizesSelect" :class="{isOpen: sizeOpen == item.id}">
                  <div class="mc-modal__outer">
                    <div class="mc-modal__inner">
                      <div class="mc-modal__heading">
                        <button @click="sizeOpen = false" class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
                          <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
                            <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
                          </svg>
                        </button>
                        <div class="mc-modal__title">
                          Размер
                        </div>
                      </div>
                      <div class="mc-modal__body">
                        <ul class="mc-options">
                          <li v-for="size in item.sizes" class="mc-options__item">
                            <button @click="item.new_size = size.VALUE" :class="{isSelected: item.new_size == size.VALUE}" class="mc-options__button" type="button">
                              {{ size.VALUE }}
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div class="mc-modal__bottom">
                        <button @click="changeSize(item)" class="mc-button mc-button--color js-button-close simulated-hover" type="button">
                                                        <span class="mc-button__text">
                                                            Применить
                                                        </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ul class="mc-cart-item__tools mc-card-tools">
                <li class="mc-card-tools__item">
                  <button @click="addToFavorite(item.base_id)"
                      :class="{ isFilled: counterFavoriteData && counterFavoriteData.ids && counterFavoriteData.ids.includes(item.base_id) }"
                      class="mc-card-tools__button simulated-hover" type="button" aria-label="Добавить в избранное">
                    <svg class="mc-card-tools__icon" width="20" height="20" viewBox="0 0 20 20">
                      <use xlink:href="/assets/svg/sprite.svg#icon-favorite"></use>
                    </svg>
                  </button>
                </li>
                <li class="mc-card-tools__item">
                  <button @click="removeFromCart(item.id)" class="mc-card-tools__button simulated-hover" type="button" aria-label="Удалить">
                    <svg class="mc-card-tools__icon" width="20" height="20" viewBox="0 0 20 20">
                      <use xlink:href="/assets/svg/sprite.svg#icon-cross-1"></use>
                    </svg>
                  </button>
                </li>
              </ul>

              <picture class="mc-cart-item__picture">
                <router-link :to="item.url">
                <img class="mc-cart-item__image" :src="item.picture" width="91" height="152" alt="">
                </router-link>
              </picture>

            </div>
            <div class="mc-cart-item__body">
              <div class="mc-cart-item__heading">
                <router-link :to="item.url"class="mc-cart-item__title">
                  {{ item.name }}
                </router-link>
                <div class="mc-cart-item__code">
                  {{ item.artnumber }}
                </div>
                <div class="mc-cart-item__price mc-price">
                                        <span class="mc-price__old" v-if="item.price_old > item.price">
                                            {{ item.price_old }} ₽
                                        </span>
                  <span class="mc-price__current">
                                            {{ item.price }} ₽
                                        </span>
                </div>
              </div>
              <div class="mc-cart-item__counter mc-counter">
                <button :disabled="item.quantity <= 1" @click="item.quantity--; changeQuantity(item)" class="mc-counter__button js-button-minus simulated-hover" type="button">
                  <svg class="mc-counter__button-icon" width="18" height="18" viewBox="0 0 18 18">
                    <use xlink:href="/assets/svg/sprite.svg#icon-minus"></use>
                  </svg>
                </button>
                <input class="mc-counter__qty" type="text" data-step="1" v-model="item.quantity">
                <button @click="item.quantity++; changeQuantity(item)" class="mc-counter__button js-button-plus simulated-hover" type="button">
                  <svg class="mc-counter__button-icon" width="18" height="18" viewBox="0 0 18 18">
                    <use xlink:href="/assets/svg/sprite.svg#icon-plus"></use>
                  </svg>
                </button>
              </div>
              <div class="mc-cart-item__availability">
                <button v-if="false" @click="showStoreModal(item.product_id)" class="mc-underline-link js-modal-button" data-target="availabilityInStores" type="button">
                                        <span class="mc-underline-link__text">
                                            Наличие в магазинах
                                        </span>
                </button>
                <div v-if="false" class="mc-modal mc-modal--h100" id="availabilityInStores">
                  <div class="mc-modal__outer">
                    <div class="mc-modal__inner">
                      <div class="mc-modal__heading">
                        <button class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
                          <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
                            <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
                          </svg>
                        </button>
                        <div class="mc-modal__title">
                          Наличие в магазинах
                        </div>
                      </div>
                      <div class="mc-modal__body">
                        <div class="mc-availability">
                          <section class="mc-availability__tabs mc-tabs mc-tabs--fr">
                            <div class="mc-tabs__button-wrapper">
                              <ul class="mc-tabs__list">
                                <li class="mc-tabs__item isActive">
                                  <button class="mc-tabs__button js-button-tab" data-name="content1" type="button">
                                    На карте
                                  </button>
                                </li>
                                <li class="mc-tabs__item">
                                  <button class="mc-tabs__button js-button-tab" data-name="content2" type="button">
                                    Списком
                                  </button>
                                </li>
                                <li class="mc-tabs__glide"></li>
                              </ul>
                            </div>
                            <div class="mc-tabs__static">
                              <div class="mc-select">
                                <button class="mc-select__button js-modal-button" data-target="availabilityCity" type="button">
                                  Санкт-Петербург
                                </button>
                              </div>
                            </div>
                            <div class="mc-tabs__body-wrapper">
                              <div class="mc-tabs__body isActive" id="content1">
                                <div class="mc-availability__map" data-address-a-ltd="59.936215" data-address-a-lgd="30.333655" data-address-b-ltd="59.961368" data-address-b-lgd="30.304415"></div>
                              </div>
                              <div class="mc-tabs__body" id="content2">
                                <ul class="mc-availability__list">
                                  <li class="mc-availability__item mc-availability-card">
                                    <div class="mc-availability-card__title">
                                      Гранд Палас
                                    </div>
                                    <ul class="mc-availability-card__info-list">
                                      <li class="mc-availability-card__info-item">
                                        г. Санкт-Петербург, Итальянская, 15
                                      </li>
                                      <li class="mc-availability-card__info-item">
                                        Режим работы: 11.00-21.00
                                      </li>
                                      <li class="mc-availability-card__info-item">
                                        Телефон: +7 (921) 425-69-33
                                      </li>
                                    </ul>
                                    <ul class="mc-availability-card__features-list">
                                      <li class="mc-availability-card__features-item">
                                        <img class="mc-availability-card__features-icon" src="/assets/svg/icon-dress.svg" width="15" height="15" alt="">
                                        Примерочная
                                      </li>
                                      <li class="mc-availability-card__features-item">
                                        <img class="mc-availability-card__features-icon" src="/assets/svg/icon-cardholder.svg" width="15" height="15" alt="">
                                        Возможность оплаты картой
                                      </li>
                                    </ul>
                                    <div class="mc-availability-card__bottom">
                                      В наличии: 1
                                    </div>
                                  </li>
                                  <li class="mc-availability__item mc-availability-card">
                                    <div class="mc-availability-card__title">
                                      Большой проспект
                                    </div>
                                    <ul class="mc-availability-card__info-list">
                                      <li class="mc-availability-card__info-item">
                                        г. Санкт-Петербург, П.С., Большой проспект, 60
                                      </li>
                                      <li class="mc-availability-card__info-item">
                                        Режим работы: 11.00-21.00
                                      </li>
                                      <li class="mc-availability-card__info-item">
                                        Телефон: +7 (921) 425-69-33
                                      </li>
                                    </ul>
                                    <ul class="mc-availability-card__features-list">
                                      <li class="mc-availability-card__features-item">
                                        <img class="mc-availability-card__features-icon" src="/assets/svg/icon-dress.svg" width="15" height="15" alt="">
                                        Примерочная
                                      </li>
                                      <li class="mc-availability-card__features-item">
                                        <img class="mc-availability-card__features-icon" src="/assets/svg/icon-cardholder.svg" width="15" height="15" alt="">
                                        Возможность оплаты картой
                                      </li>
                                    </ul>
                                    <div class="mc-availability-card__bottom">
                                      В наличии: 1
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="false" class="mc-modal" id="availabilityCity">
                  <div class="mc-modal__outer">
                    <div class="mc-modal__inner">
                      <div class="mc-modal__heading">
                        <button class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
                          <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
                            <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
                          </svg>
                        </button>
                        <div class="mc-modal__title">
                          Город
                        </div>
                      </div>
                      <div class="mc-modal__body">
                        <ul class="mc-filter__option-list mc-options">
                          <li class="mc-options__item">
                            <button class="mc-options__button isSelected" type="button">
                              Санкт-Петербург
                            </button>
                          </li>
                          <li class="mc-options__item">
                            <button class="mc-options__button" type="button">
                              Москва
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          </template>
        </ul>
        <div class="mc-cart-form__promo mc-promo">
          <div class="mc-promo__field">
            <label class="mc-promo__label" for="cartFormPromo">
              Промокод
            </label>
            <input class="mc-promo__input" id="cartFormPromo" type="text" placeholder="Введите промокод" v-model="newpromocode">
            <button @click="savePromocode" class="mc-promo__button" type="button">
              <svg class="mc-promo__button-icon" width="24" height="24" viewBox="0 0 24 24">
                <use xlink:href="/assets/svg/sprite.svg#arrow-chevron-right"></use>
              </svg>
            </button>
          </div>
          <div class="mc-promo__result">
            <template v-for="item in promocode">
              <div :class="{'mc-message--success':item.valid, 'mc-message--alert':item.valid==false}" class="mc-promo__message mc-message">
                                <span class="mc-message__content">
                                    {{ item.coupon }} {{item.valid?'применен':'не найден'}}.
                                </span>
                <button @click="deletePromocode(item.coupon)" class="mc-message__button-delete" type="button">
                  Удалить
                </button>
              </div>
            </template>
          </div>
        </div>
        <div class="mc-cart-form__calculation mc-calculation">
          <div class="mc-calculation__item">
                            <span class=" mc-calculation__cell">
                                Товаров на сумму
                            </span>
            <span class="mc-calculation__cell">
                                {{basket.full_price}}  ₽
                            </span>
          </div>
          <div v-if="basket.discount > 0" class="mc-calculation__item">
                            <span class="mc-calculation__cell">
                                Скидка
                            </span>
            <span class="mc-calculation__cell">
                                -{{basket.discount}}  ₽
                            </span>
          </div>
          <div class="mc-calculation__item mc-calculation__item--big">
                            <span class="mc-calculation__cell">
                                Итого
                            </span>
            <span class="mc-calculation__cell">
                                {{basket.price}}  ₽
                            </span>
          </div>
        </div>
        <div class="mc-cart-form__bottom">
          <router-link to="/order/"  class="mc-button mc-button--color" type="submit">
                            <span class="mc-button__text">
                                Оформить заказ на {{ basket.price }} ₽
                            </span>
          </router-link>
        </div>
      </form>
      <template v-if="basketLoaded && basket.quantity == 0">
        <p>Ваша корзина пуста</p>
        <router-link to="/catalog/" class="mc-outfit__cta-button mc-button simulated-hover">Перейти в каталог</router-link>
      </template>
    </div>
  </div>

  <ProductStore v-if="isOpenStore" :key="currentOffer" :id="currentOffer" :isOpen="isOpenStore" @close="isOpenStore=false"></ProductStore>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProductStore from "@/views/blocks/ProductStore.vue";
import num from "../mixin/num.vue";
export default {
  data: () => ({
    sizeOpen: false,
    isOpenStore: false,
    currentOffer: false,
    newpromocode: ''
  }),
  mixins: [num],
  mounted() {

  },
  created() {
    this.fetchBasket();
    this.fetchPromocode();
  },
  computed: {
    ...mapGetters([
      'basket',
      'basket_items',
      'basketLoading',
      'basketError',
      'basketLoaded',
      'counterFavoriteData',
      'promocode',
      'promocodeLoading',
      'promocodeError',
      'promocodeLoaded',
    ]),
  },
  components: {ProductStore},
  methods: {
    ...mapActions([
      'fetchBasket',
        'addToFavorite',
        'removeFromCart',
        'setQuantity',
        'addToBasket',
        'fetchPromocode',
        'addPromocode',
        'removePromocode',
        'fetchCounterData'
    ]),
    showStoreModal(id) {
      this.currentOffer = id;
      this.isOpenStore = true;
    },
    changeSize(item) {
      this.sizeOpen = false;
      let id;
      for (let i in item.sizes) {
        if (item.sizes[i].VALUE == item.new_size) {
          id = item.sizes[i].ID;
          break;
        }
      }
      console.log(id)
      this.addToBasket({productId: id, quantity: item.quantity});
      this.removeFromCart(item.id);
    },
    async changeQuantity(item) {
      await this.setQuantity({id: item.id, quantity: item.quantity});
      this.fetchCounterData(true);
    },
    savePromocode() {
      this.addPromocode(this.newpromocode);
      this.newpromocode = '';
    },
    deletePromocode(promocode) {
      this.removePromocode(promocode);
    }
  },
}
</script>

